import Clarity from "@microsoft/clarity";
import type { SanitizedAuth0User } from "@/plugins/launchDarkly/utils";
import { getClarityProjectId } from "@/utils/platform.config";

class ClarityService {
  private hasInitialized = false;
  private hasTrackingConsent = false;
  private lastIdentifiedUserKey: string | null = null;

  public initialize(): void {
    const projectId = getClarityProjectId();

    if (!projectId || this.hasInitialized) {
      return;
    }

    Clarity.init(projectId);
    this.hasInitialized = true;
  }

  public enableTracking(): void {
    this.initialize();

    if (!this.hasInitialized || this.hasTrackingConsent) {
      return;
    }

    Clarity.consentV2({ ad_Storage: 'granted', analytics_Storage: 'granted' });
    this.hasTrackingConsent = true;
  }

  public disableTracking(): void {
    if (!this.hasInitialized || !this.hasTrackingConsent) {
      return;
    }

    Clarity.consentV2({ ad_Storage: 'denied', analytics_Storage: 'denied' });
    this.hasTrackingConsent = false;
    this.lastIdentifiedUserKey = null;
  }

  public identifyAuthenticatedUser(user: SanitizedAuth0User): void {
    if (!this.hasInitialized || !this.hasTrackingConsent || !user.sub) {
      return;
    }

    if (this.lastIdentifiedUserKey === user.sub) {
      return;
    }

    Clarity.identify(user.sub);
    Clarity.setTag("organizationName", user.organizationName);
    Clarity.setTag("ownerRole", user.ownerRole);
    if (user.roles.length > 0) {
      Clarity.setTag("roles", user.roles);
    }

    this.lastIdentifiedUserKey = user.sub;
  }
}

export const clarityService = new ClarityService();
